import BreadCrumb from '@components/common/BreadCrumb';
import { ContentTitle } from '@components/common/ContentTitle';
import MetaSeo from '@components/common/MetaSeo';
import { KakaoMapLauncher } from '@components/page/cs/KaKaoMap';
import { MainContent } from '@styles/components/LayoutStyle';
import { NextPage } from 'next';
import React, { useEffect } from 'react';
import { FaEnvelope, FaHeadphonesAlt, FaMapMarkedAlt, FaMapMarkerAlt, FaPhoneVolume, FaSubway } from 'react-icons/fa';
import styled from 'styled-components';
import { SITE_CONFIG } from '@config/siteConfig';

const CsItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  @media only screen and (max-width: 680px) {
    flex-direction: column;
  }
`;

const CsItem = styled.div`
  border: 1px solid #e9e9e9;
  display: flex;
  justify-content: center;
  width: 32%;
  padding: 20px 0;
  position: relative;
  height: 350px;

  &:hover {
    border-color: #1890ff;
  }

  @media only screen and (max-width: 680px) {
    width: 100%;
    height: 200px;
    justify-content: space-around;
    align-items: center;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 10px;
  }
`;

const CsItemTop = styled.div`
  border: 1px solid #e9e9e9;
  border-radius: 50%;
  padding: 25px;
  width: 110px;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 680px) {
    width: 90px;
    height: 90px;
  }

  .cs-top-icon {
    font-size: 50px;
    color: #5368f5;

    @media only screen and (max-width: 680px) {
      font-size: 35px;
    }
  }
`;

const CsItemBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 190px;
  position: absolute;
  top: 150px;
  padding-top: 20px;

  @media only screen and (max-width: 680px) {
    height: auto;
    position: initial;
    padding-top: 0;
  }
`;

const CsItemTitle = styled.h3`
  font-size: 23px;
  font-weight: 600;
  margin-bottom: 15px;

  @media only screen and (max-width: 680px) {
    font-size: 18px;
  }
`;

const CsItemSubTitle = styled.span`
  font-size: 17px;
  font-weight: 500;

  @media only screen and (max-width: 680px) {
    font-size: 14px;
  }
`;

const CsItemText = styled.span`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 7px;

  @media only screen and (max-width: 680px) {
    font-size: 12px;
  }
`;

const MapAreaContainer = styled.section`
  display: flex;

  @media only screen and (max-width: 680px) {
    flex-direction: column;
  }
`;

const MapWrapper = styled.section`
  width: 700px;
  height: 300px;
  margin-right: 30px;

  @media only screen and (max-width: 680px) {
    width: 100%;
    max-width: 680px;
    margin-right: 0;
  }
`;

const MapTextWrapper = styled.div`
  @media only screen and (max-width: 680px) {
    margin-top: 10px;
  }
`;

const SITE_INFO = {
  upper: '고객센터',
  title: '고객센터',
  description: '대기업과 중소기업의 상생, 그 이상을 연결하는 동반성장몰과 지금 함께하세요.',
};

const Index: NextPage = () => {
  useEffect(() => {
    KakaoMapLauncher('kakao-map', '37.52947', '126.875937');
  }, []);

  return (
    <>
      <MetaSeo title={SITE_INFO.title} description={SITE_INFO.description} />
      <MainContent>
        <BreadCrumb upper={SITE_INFO.upper} title={SITE_INFO.title} />

        <ContentTitle>
          대기업과 중소기업의 <strong style={{ color: '#5368F5' }}>상생, 그 이상을 연결하는 동반성장몰</strong>과 지금
          함께하세요.
        </ContentTitle>

        <CsItemWrapper>
          <CsItem>
            <CsItemTop>
              <FaEnvelope className="cs-top-icon" />
            </CsItemTop>
            <CsItemBottom>
              <CsItemTitle>이메일 및 주소</CsItemTitle>
              <CsItemSubTitle>중소기업 상품입점</CsItemSubTitle>
              <CsItemText>https://fanfandaero.kr</CsItemText>
              <CsItemSubTitle>대기업·공공기관 사업도입</CsItemSubTitle>
              <CsItemText style={{marginBottom : 0}}>ruda@{SITE_CONFIG.domain}</CsItemText>
              <CsItemText>hwan@{SITE_CONFIG.domain}</CsItemText>
            </CsItemBottom>
          </CsItem>
          <CsItem>
            <CsItemTop>
              <FaPhoneVolume className="cs-top-icon" />
            </CsItemTop>
            <CsItemBottom>
              <CsItemTitle>전화번호</CsItemTitle>
              <CsItemSubTitle>중소기업 상품입점</CsItemSubTitle>
              <CsItemText>02-6678-9821~28</CsItemText>
              <CsItemSubTitle>대기업·공공기관 사업도입</CsItemSubTitle>
              <CsItemText>02-6678-9828</CsItemText>
            </CsItemBottom>
          </CsItem>
          <CsItem>
            <CsItemTop>
              <FaHeadphonesAlt className="cs-top-icon" />
            </CsItemTop>
            <CsItemBottom>
              <CsItemTitle>헬프데스크</CsItemTitle>
              <CsItemSubTitle>동반성장몰 이용 관련 문의</CsItemSubTitle>
              <span style={{ fontSize: 30, fontWeight: 600 }}>{SITE_CONFIG.call}</span>
            </CsItemBottom>
          </CsItem>
        </CsItemWrapper>

        <h3 style={{ fontSize: 22, marginBottom: 10, fontWeight: 600 }}>
          <FaMapMarkerAlt style={{ marginRight: 10, color: '#5368F5' }} /> 오시는 길
        </h3>

        <MapAreaContainer>
          <MapWrapper>
            <div id="kakao-map" style={{ height: '100%' }} />
          </MapWrapper>
          <MapTextWrapper>
            <div style={{ width : 400 }}>
              <h5 style={{ fontSize: 20, marginBottom: 10 }}>
                <FaMapMarkedAlt style={{ marginRight: 10, color: '#5368F5' }} />
                주소
              </h5>
              <div itemScope itemType="https://schema.org/Organization">
                <span style={{ padding: '0 10px', fontWeight: 600 }} itemProp="name">
                  {SITE_CONFIG.siteName}
                </span>
                <address
                  style={{ padding: '0 10px' }}
                  itemProp="address"
                  itemScope
                  itemType="https://schema.org/PostalAddress">
                  <span itemProp="postalCode">07997 </span>
                  <span itemProp="addressRegion">서울특별시 </span>
                  <span itemProp="addressLocality">양천구 </span>
                  <span itemProp="streetAddress">목동동로 309 한국중소벤처기업유통원 3층 온라인지원실 동반성장몰팀</span>
                </address>
              </div>
            </div>
            <div style={{ marginTop: 30 }}>
              <h5 style={{ fontSize: 20, marginBottom: 10 }}>
                <FaSubway style={{ marginRight: 10, color: '#5368F5' }} />
                지하철
              </h5>
              <p style={{ padding: '0 10px' }}>
                <span
                  style={{
                    background: 'blueviolet',
                    color: 'white',
                    padding: '3px 7px',
                    marginRight: 5,
                    borderRadius: 7,
                  }}>
                  5호선
                </span>
                오목교역 2번출구 방면
              </p>
            </div>
          </MapTextWrapper>
        </MapAreaContainer>
      </MainContent>
    </>
  );
};

export default Index;
